import { Divider, Skeleton } from "antd";
import moment from "moment-timezone";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { updateOfferedCandidateProfile } from "../../pages/Profile/actions";
import { profileDataValidation, showErrorToast } from "../../utils/Functions";
import { ProfileCancelButton, ProfileSaveButton } from "./ProfileButtons";
import ErrorMessage from "../../utils/ErrorMessage";

const EducationDetail = ({
  educationalDetails,
  candidateId,
  isGuest,
  educationdetails,
  setEducationDetails,
  errors,
  setErrors,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.profile.loading);

  const [isEditEducationDetails, setIsEditEducationDetails] = useState(false);

  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  let emptyDetails = [{ from: "", institute: "", major: "", to: "" }];

  useEffect(() => {
    if (!isGuest) {
      if (educationalDetails?.length > 0) {
        setEducationDetails(educationalDetails);
      } else {
        educationalDetails = emptyDetails;
        setEducationDetails(educationalDetails);
      }
    } else {
      setEducationDetails(emptyDetails);
    }
  }, [educationalDetails]);

  /******************* 
  @Purpose : function for + functionality
  @Parameter : {}
  @Author : INIC
  ******************/

  const handleEducationAdd = (e) => {
    e.preventDefault();
    setEducationDetails([
      ...educationdetails,
      {
        institute: "",
        major: "",
        // degree: "",
        from: "",
        to: "",
      },
    ]);
  };

  /******************* 
   @Purpose : function for - functionality
   @Parameter : {}
   @Author : INIC
   ******************/

  const handleRemoveEducation = (index) => {
    const educationValues = [...educationdetails];
    educationValues.splice(index, 1);
    setEducationDetails(educationValues);
  };

  /******************* 
   @Purpose : function to get the value
   @Parameter : {}
   @Author : INIC
   ******************/

  const handleEduDetail = (e, index, name) => {
    const eduValues = [...educationdetails];
    eduValues[index][name] = e;
    setEducationDetails(eduValues);
  };

  const handleUpdate = async () => {
    if (validate()) {
      const payload = {
        id: candidateId,
        educations: educationdetails,
        modifiedBy: candidateId,
      };
      await dispatch(updateOfferedCandidateProfile(payload));
      setIsEditEducationDetails(false);
    }
  };
  const validate = () => {
    let isFormValid = false;
    if (educationdetails.length > 0) {
      const firstEducation = educationdetails[0];
      const hasEmptyValue = Object.values(firstEducation).some(
        (val) => val === null || val === ""
      );
      if (hasEmptyValue) {
        setErrors({ education: ErrorMessage.PROVIDE_ONE_EDUCATION });
        showErrorToast(ErrorMessage.PROVIDE_ONE_EDUCATION);
        isFormValid = false;
      } else {
        setErrors({ education: "" });
        isFormValid = true;
      }
    }
    return isFormValid;
  };

  return (
    <Fragment>
      <Col sm={12} className="pt-4 mt-2 pb-4 mb-2">
        <div className="edit-details ">
          <Divider orientation="left" orientationMargin="0" className="mb-0">
            <div className="title ">Educational Details</div>
          </Divider>

          {!isGuest && !isEditEducationDetails && (
            <div className="edit-btn">
              <Button
                variant="warning btn-edit"
                size="sm"
                onClick={() => setIsEditEducationDetails(true)}
              >
                <span className="bx bx-edit-alt"></span> Edit
              </Button>
            </div>
          )}
        </div>
      </Col>
      <Row>
        {loading && (
          <>
            <Col md={4} sm={6}>
              <Skeleton active paragraph={{ rows: 2 }} />
            </Col>
            <Col md={4} sm={6}>
              <Skeleton active paragraph={{ rows: 2 }} />
            </Col>
            <Col md={4} sm={6}>
              <Skeleton active paragraph={{ rows: 2 }} />
            </Col>
            <Col sm={12}>
              <Skeleton active paragraph={{ rows: 2 }} />
            </Col>
          </>
        )}
        {!loading && (
          <Fragment>
            {educationdetails?.map((educationDetail, index) => (
              <Fragment key={index}>
                <Col md={6} sm={6}>
                  <div className="form-group">
                    <label className="form-label">Institute/School</label>
                    {/* {index === 0 && <span className="mandatory-mark">*</span>} */}
                    {!isGuest && !isEditEducationDetails && (
                      <h6 className="mt-1 text-title">
                        {profileDataValidation(educationDetail?.institute)}
                      </h6>
                    )}
                    {(isGuest || isEditEducationDetails) && (
                      <div className="edit-inline-action">
                        <Form.Control
                          type="text"
                          value={educationDetail?.institute}
                          onChange={(e) => {
                            const re = e.target.value.replace(
                              /[^a-z / " "]/gi,
                              ""
                            );
                            handleEduDetail(re, index, "institute");
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={6} sm={6}>
                  <div className="form-group">
                    <label className="form-label">Major/Department</label>
                    {/* {index === 0 && <span className="mandatory-mark">*</span>} */}
                    {!isGuest && !isEditEducationDetails && (
                      <h6 className="mt-1 text-title">
                        {profileDataValidation(educationDetail?.major)}
                      </h6>
                    )}
                    {(isGuest || isEditEducationDetails) && (
                      <div className="edit-inline-action">
                        <Form.Control
                          type="text"
                          value={educationDetail?.major}
                          onChange={(e) => {
                            const re = e.target.value.replace(
                              /[^a-z / " "]/gi,
                              ""
                            );
                            handleEduDetail(re, index, "major");
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Col>
                {/* <Col md={4} sm={6}>
                  <div className="form-group">
                    <label className="form-label">Degree</label>
                    {index === 0 && <span className="mandatory-mark">*</span>}
                    {!isGuest && !isEditEducationDetails && (
                      <h6 className="mt-1 text-title">
                        {profileDataValidation(educationDetail?.degree)}
                      </h6>
                    )}
                    {(isGuest || isEditEducationDetails) && (
                      <div className="edit-inline-action">
                        <Form.Control
                          type="text"
                          value={educationDetail?.degree}
                          onChange={(e) => {
                            const re = e.target.value.replace(
                              /[^a-z / " "]/gi,
                              ""
                            );
                            handleEduDetail(re, index, "degree");
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Col> */}
                <Col sm={12}>
                  <div className="form-group">
                    <label className="form-label">Duration</label>
                    {/* {index === 0 && <span className="mandatory-mark">*</span>} */}
                    {!isGuest && !isEditEducationDetails && (
                      <h6 className="mt-1 text-title">
                        {profileDataValidation(educationDetail?.from)}

                        {" - "}
                        {profileDataValidation(educationDetail?.to)}
                      </h6>
                    )}
                    {(isGuest || isEditEducationDetails) && (
                      <Row>
                        <Col sm={6}>
                          <DatePicker
                            placeholderText="From"
                            className="form-control mb-sm-2"
                            value={educationDetail.from}
                            selected={endMonth}
                            onChange={(date) => {
                              let next = new Date(
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                date.getHours() + 1
                              );
                              setEndMonth(next);
                              setStartMonth(
                                new Date(date).setMonth(date.getMonth() + 1)
                              );
                              handleEduDetail(
                                moment(next).format("MM/yyyy"),
                                index,
                                "from"
                              );
                            }}
                            selectsStart
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            maxDate={new Date()}
                          />
                        </Col>{" "}
                        <Col sm={6}>
                          <DatePicker
                            placeholderText="To"
                            className="form-control"
                            // disabled={i.pursuing ? true : false}
                            minDate={startMonth || new Date()}
                            selected={endMonth}
                            value={educationDetail.to}
                            onChange={(date) => {
                              let to = new Date(date);
                              setEndMonth(new Date(date));
                              handleEduDetail(
                                moment(to).format("MM/YYYY"),
                                index,
                                "to"
                              );
                            }}
                            selectsStart
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                        </Col>
                      </Row>
                    )}
                  </div>
                </Col>
                {(isGuest || isEditEducationDetails) && (
                  <div className="edit-inline-action bottom-btns justify-content-end w-100">
                    {educationdetails.length - 1 === index && (
                      <Button
                        variant="primary btn-icon btn-icon-add"
                        size="sm"
                        onClick={(e) => {
                          handleEducationAdd(e);
                        }}
                      >
                        <span className="bx bx-plus"></span>
                      </Button>
                    )}
                    {educationdetails.length !== 1 && (
                      <Button
                        variant="secondary btn-icon btn-icon-remove"
                        size="sm"
                        onClick={() => handleRemoveEducation(index)}
                      >
                        <span className="bx bx-minus"></span>
                      </Button>
                    )}
                    {!isGuest && educationdetails.length - 1 === index && (
                      <ProfileSaveButton
                        onClick={() => {
                          if (educationdetails.length > 0) {
                            handleUpdate();
                          }
                        }}
                      />
                    )}
                    {!isGuest && educationdetails.length - 1 === index && (
                      <ProfileCancelButton
                        onClick={() => {
                          setIsEditEducationDetails(false);
                          if (educationalDetails?.length > 0) {
                            setEducationDetails(educationalDetails);
                          } else {
                            setEducationDetails(emptyDetails);
                          }
                        }}
                      />
                    )}
                  </div>
                )}
              </Fragment>
            ))}
          </Fragment>
        )}
      </Row>
    </Fragment>
  );
};

export default EducationDetail;
